<template>
    <div class="edit_wrap">
        <div class="edit_top">
            <div class="edit_tab">供应商信息</div><!--
    --><div class="edit_tab active_tab">品牌信息</div><!--
    --><div class="edit_tab">财务信息</div><!--
    --><div class="edit_tab">合同协议</div>
        </div>
        <div class="tip_word">
            <el-row>
                <el-col :span="2">
                    <div class="grid-content">友情提示：</div>
                </el-col>
                <el-col :span="22"><div class="grid-content f12 f666 lh20">1.请按照大V服务平台信息要求填写正确的供应商信息。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">3.提交审核之后，大V店工作人员会在3个工作日内进行审核。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">4.入驻过程有任何疑问，请按照如下方式解决：<br>（1）如果有对接的采销，请直接联系采销处理解决；<br>（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">5.<a target="_blank" href="/suppliers/index2/#/intro"><span style="color: #58b7ff">点击此处</span></a>查看供应商入驻介绍。</div></el-col>
            </el-row>
        </div>
        <div class="mt20 ovh min_height">
            <router-link v-if="showButton == 1" :to="categoryIsBook==1 ? '/add_brand?supplierApplyId=' + supplierApplyId + '&id=0&registeredCountry=' + registeredCountry : '/notbook_addbrand?supplierApplyId=' + supplierApplyId + '&id=0&registeredCountry=' + registeredCountry">
                <el-button class="r mr20 mb20" type="primary">申请品牌</el-button>
            </router-link>
            <el-table :data="brandList" style="width: 100%" border>
                <el-table-column prop="brandName" label="品牌中文名称" min-width="100" align="center">
                </el-table-column>
                <el-table-column prop="brandEnname" label="品牌英文名称" min-width="100" align="center">
                </el-table-column>
                <el-table-column prop="categoryName" label="经营品类" align="center" min-width="300">
                    <template scope="scope">
                        <p v-for="category in scope.row.supplierApplyBrandCategories">{{category.category.grandName}}-{{category.category.parentName}}-{{category.category.childrenName}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="statusDesc" label="审核状态" align="center">
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template scope="scope">
                        <router-link v-if="showButton == 1 || showEditButton == 1"  :to="categoryIsBook==1 ? '/add_brand?id=' + scope.row.brandApplyId + '&supplierApplyId=' + supplierApplyId + '&registeredCountry=' + registeredCountry : '/notbook_addbrand?id=' + scope.row.brandApplyId + '&supplierApplyId=' + supplierApplyId + '&registeredCountry=' + registeredCountry">
                            <el-button type="text" size="small">编辑</el-button>
                        </router-link>
                        <el-button v-if="showButton == 1" type="text" size="small" @click="deleBrand(scope.row.brandApplyId)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tc mt50 mb50">
                <el-button class="mr50" type="primary" @click="goBasic">上一步</el-button>
                <el-button :disabled="isNoNext" type="primary" @click="goFinan">下一步</el-button>
            </div>
        </div>
    </div>

</template>

<script type="text/javascript">
	export default {
		data () {
			return {
			    showButton: 1,//是否显示申请品牌按钮
                showEditButton:0,//是否显示编辑按钮
                categoryIsBook: 0,       // 是否为图书
                registeredCountry: 0,    // 注册国家
                supplierApplyId: 0,      // 申请id
				isNoNext: true,				// 下一步 按钮状态
				brandList: [],
			}
		},
		methods: {
			fetch () {
			    var _this = this;
			    var supplierApplyId = this.$route.query.supplierApplyId;
			    this.supplierApplyId = supplierApplyId;
				// ajax
                $.get({
                    url: '/suppliers/supplierSettled/findSupplierApplyBrands',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.brandList = result.data.list;
                            _this.registeredCountry = result.data.registeredCountry;
                            _this.categoryIsBook = result.data.categoryIsBook;
                            if (result.data.list.length > 0) {
                                var status = result.data.list[0].status;
                                if(status == 9) {//驳回资质不可编辑、修改品牌信息
                                    _this.showButton = 0;
                                    _this.showEditButton = 1;
                                }
                                if(status!=1 && status!=3 && status!=9) {
                                    if(status == 5) {
                                        // 后台成功 改变路由
                                        _this.$router.push({
                                            path:'/supplier_apply_audit',
                                            query:{supplierApplyId: supplierApplyId}
                                        })
                                    }else{
                                        // 后台成功 改变路由
                                        _this.$router.push({
                                            path:'/supplier_skan',
                                            query:{supplierApplyId: supplierApplyId}
                                        })
                                    }
                                }
                                _this.isNoNext = false;
                            } else {
                                _this.isNoNext = true;
                            }
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                             _this.$message({
                               showClose: true,
                               message: result.msg,
                               type: 'error'
                             });
                        }
                    }
                })
				// 通过 brandList的length 判断 isNoNext 状态

			},
			formatter (row) {
				if (row.status == 1) {
					return "待审核"
				} else {
					return "已审核"
				}
			},

            // 进入财务信息
            goFinan () {
			    var _this = this;
                this.$router.push({
                    path:'/edit_info_finance?supplierApplyId=' + _this.supplierApplyId
                })
            },
            // 返回基础信息
            goBasic () {
                var _this = this;
                this.$router.push({
                    path:'/edit_info_basic?supplierApplyId=' + _this.supplierApplyId
                })
            },
            // 删除品牌信息
            deleBrand (id) {
                var _this = this;
                var brandApplyId = parseInt(id);
                $.ajax({
                    url: '/suppliers/supplierSettled/deleteSupplierApplyBrand?brandApplyId=' + brandApplyId,
                    type: 'delete',
                    data: {
                        brandApplyId: brandApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            _this.$message({
                                showClose: true,
                                message: '删除成功',
                                type: 'success'
                            });
                            var brandList = _this.brandList;
                            var newBrandList = [];
                            for(var i = 0; i < brandList.length; i++) {
                                var brand = {};
                                brand = brandList[i];
                                if (brand.brandApplyId == brandApplyId) {

                                } else {
                                    newBrandList.push(brand);
                                }
                                _this.brandList = newBrandList;
                            }

                            /*setTimeout(function () {
                                _this.$router.push({
                                    path:'/edit_info_brand?supplierApplyId=' + _this.supplierApplyId
                                })
                            },500)*/
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            }
		},
        mounted () {
		    this.fetch();
        }
	}
</script>

<style type="text/css" lang="less" scoped>
	.min_height {
		min-height: 300px;
	}
    .edit_wrap {
        width: 1050px;
        margin: 50px auto;
        border: 1px solid #eee;
    .edit_tab {
        display: inline-block;
        width: 262px;
        height: 46px;
        text-align: center;
        line-height: 46px;
        color: #fff;
        background: #ff6c83;
    }
    .active_tab {
        background: #ff4a7d;
    }
    .tip_word {
        margin-top: 20px;
        width: 1048px;
        height: 160px;
        background: #f9f9f9;
        padding: 10px;
    }
    }
    .lh20 {
        line-height: 20px;
    }
</style>


// WEBPACK FOOTER //
// brandInfo.vue?4872b2df